import {
	SET_FORM_STATE,
} from '../actions/HuaweiRemoteAnalysisActions.js';

const initialState = {
	formState: {
		huaweiRemoteAnalysis: {
			isValid: false,
			values: {},
			touched: {},
			errors: {},
		}
	},
};

const huaweiRemoteAnalysisReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					default: {
						return state;
					}
	}
};

export default huaweiRemoteAnalysisReducer;
